import Size from 'ui/types/size';
import styled, { css, ExecutionContext } from 'styled-components';

export type ImageSize = Size | 'xlarge';

export interface ImageProps {
  $size?: ImageSize;
  $bordered?: boolean;
  $circular?: boolean;
}

function getSize({ theme, $size }: ExecutionContext & ImageProps) {
  if (!$size) return null;

  const size = theme.images.size[$size];

  return css<ImageProps>`
    max-width: ${size}px;
    max-height: ${size}px;
  `;
}

function getBorderedImage({ $bordered }: ExecutionContext & ImageProps) {
  if (!$bordered) return null;

  return css<ImageProps>`
    border-radius: 8px;
    box-shadow: 0px 5px 5px -3px #00000033, 0px 3px 14px 2px #0000001f, 0px 8px 10px 1px #00000024;
  `;
}

function getCircularImage({ $circular, $bordered }: ExecutionContext & ImageProps) {
  if (!$circular) return null;

  if (!$bordered) {
    return css`
      border-radius: 500em;
    `;
  }
}

export const Image = styled.img<ImageProps>`
  ${getBorderedImage};
  ${getCircularImage};
  ${getSize};
`;
